<template>
  <div class="cCardView">
    <card-method></card-method>
  </div>
</template>

<script>
// @ is an alias to /src
import cardMethod from "@/components/methods/cardMethod.vue";

export default {
  name: "card",

  components: {
    cardMethod
  },
  created() {}
};
</script>


